import React from 'react';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

//modal imports
import { Polygon, Marker, InfoWindow } from '@react-google-maps/api';

import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';
import useLayerContext from 'contexts/layerContext';
import { wsUpdate } from 'services/WService';

export default function ModalMap(props) {
  const {
    mapRef,
    setMapRef,
    mapCenter,
    setMapCenter,
    newPolygonRef,
    newPolygon,
    showAddresses,
    addresses,
    showMarkerLabels,
    draggable,
    newMarker,
    setNewMarker,
    setDraggable,
    onMouseUpEdit,
    buttonUpdate,
    routePolygon,
    route,
    showReferenceRoutes,
    filteredRefferenceRoutes,
    setHoverDescription,
    showOriginalGeometry,
    originalRoute,
    openInfo,
    infoData,
    setOpenInfo,
    setInfoData,
    classes,
  } = props;
  const { showNotify, getAddress, changeEditedPolygon } = props;

  const { selectedLayer } = useLayerContext();

  async function udateMarker(latLng) {
    if (selectedLayer.id === undefined) {
      showNotify('Seleccione una capa', 'info');
      return;
    }
    let response = await wsUpdate('base/address', draggable.idAddress, {
      ...latLng,
      base_layer_id: selectedLayer.id,
    });
    if (response.success) {
      showNotify(response.message);
      getAddress();
      setDraggable({
        state: false,
        icon: '',
        idAddress: null,
      });
    } else {
      showNotify(response.message, 'error');
    }
  }

  function onDblClick(polygon) {
    changeEditedPolygon(polygon);
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12} className={classes.grid}>
        <GoogleMapCustom
          onMouseOut={() => {
            setHoverDescription(null);
          }}
          onLoad={(map) => {
            setMapRef(map);
          }}
          mapContainerStyle={{
            width: '100%',
            // height: '80%',
            minHeight: '620px',
          }}
          zoom={14}
          center={mapCenter}
          onDragEnd={() => {
            if (!mapRef) return;
            let center = {
              lat: mapRef.center.lat(),
              lng: mapRef.center.lng(),
            };
            setMapCenter(center);
          }}
          options={{
            disableDoubleClickZoom: true,
          }}
          onClick={() => {
            setOpenInfo(false);
            setDraggable({
              state: false,
              icon: '',
              idAddress: null,
            });
          }}
          onRightClick={(e) => {
            alert(`Lat: ${e.latLng.lat()}\nLng: ${e.latLng.lng()}`);
          }}
        >
          {!!newPolygon ? (
            <Polygon
              ref={newPolygonRef}
              editable
              draggable
              options={{
                fillColor: 'green',
              }}
              paths={newPolygon.paths}
            />
          ) : undefined}

          {showAddresses &&
            addresses
              .filter((address) => address.latitude != '0')
              .map((address, i) => {
                return (
                  <Marker
                    onMouseOver={(e) => {
                      setHoverDescription('Dirección: ' + address.Address2);
                    }}
                    key={i}
                    zIndex={10}
                    position={{
                      lat: parseFloat(address.latitude),
                      lng: parseFloat(address.longitude),
                    }}
                    onClick={() => {
                      setOpenInfo(true);
                      setInfoData(address);
                    }}
                    onMouseOut={() => {
                      setHoverDescription('"Pase el mouse por un polígono o marcador"');
                    }}
                    onRightClick={() => {
                      setDraggable({
                        state: true,
                        icon: '/img/marker.png',
                        idAddress: address.id,
                      });
                      setNewMarker({
                        lat: parseFloat(address.latitude),
                        lng: parseFloat(address.longitude),
                      });
                    }}
                    icon={
                      draggable.idAddress == address.id && draggable.state
                        ? draggable.icon
                        : address.state === 'A' && address.frozenFor === 'N'
                        ? undefined
                        : '/img/marker_gray.png'
                    }
                    label={
                      showMarkerLabels
                        ? {
                            color: 'white',
                            className: 'map-label',
                            text: address.CardName.substr(0, address.CardName.indexOf(' ')),
                          }
                        : undefined
                    }
                  />
                );
              })}

          {draggable.state ? (
            <Marker
              zIndex={100}
              position={{
                lat: newMarker.lat,
                lng: newMarker.lng,
              }}
              draggable={true}
              icon={'/img/mark.png'}
              onDragEnd={(e) => {
                setNewMarker({
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                });
              }}
              onRightClick={(e) => {
                udateMarker({
                  latitude: e.latLng.lat().toString(),
                  longitude: e.latLng.lng().toString(),
                });
              }}
            />
          ) : undefined}

          {!!route ? (
            !!route.geometry ? (
              originalRoute === undefined ? (
                <Polygon
                  onClick={() => {
                    setDraggable({
                      state: false,
                      icon: '',
                      idAddress: null,
                    });
                  }}
                  onMouseOver={(e) => {
                    setHoverDescription('Ruta: ' + route.description);
                  }}
                  options={{
                    fillColor: buttonUpdate ? 'green' : undefined,
                  }}
                  paths={route.geometry}
                  onMouseOut={() => {
                    setHoverDescription('"Pase el mouse por un polígono o marcador"');
                  }}
                />
              ) : (
                <Polygon
                  onClick={() => {
                    setDraggable({
                      state: false,
                      icon: '',
                      idAddress: null,
                    });
                  }}
                  onMouseOver={(e) => {
                    setHoverDescription('Ruta: ' + route.description);
                  }}
                  onMouseUp={onMouseUpEdit}
                  editable={buttonUpdate}
                  draggable={buttonUpdate}
                  options={{
                    fillColor: buttonUpdate ? 'green' : undefined,
                  }}
                  ref={routePolygon}
                  paths={route.geometry}
                  onMouseOut={() => {
                    setHoverDescription('"Pase el mouse por un polígono o marcador"');
                  }}
                />
              )
            ) : undefined
          ) : undefined}

          {showReferenceRoutes &&
            filteredRefferenceRoutes.map((routeRef, i) => {
              return !!routeRef.geometry ? (
                <Polygon
                  onMouseOver={(e) => {
                    setHoverDescription('Ruta: ' + routeRef.description);
                  }}
                  key={i}
                  onDblClick={() => onDblClick(routeRef)}
                  paths={routeRef.geometry}
                  options={{
                    fillColor: routeRef.layer.color,
                  }}
                  onMouseOut={() => {
                    setHoverDescription('"Pase el mouse por un polígono o marcador"');
                  }}
                />
              ) : undefined;
            })}

          {/* Poligono guía */}
          {showOriginalGeometry && originalRoute !== undefined ? (
            <Polygon
              options={{
                fillOpacity: 0.1,
                zIndex: -1,
              }}
              paths={originalRoute.geometry}
            />
          ) : undefined}

          {openInfo ? (
            <InfoWindow
              position={{
                lat: parseFloat(infoData.latitude),
                lng: parseFloat(infoData.longitude),
              }}
              onCloseClick={() => {
                setOpenInfo(false);
                setInfoData({});
              }}
              options={{
                pixelOffset: {
                  width: 0,
                  height: -25,
                },
              }}
            >
              <div className={classes.divStyle}>
                <li>
                  <span>Nombre: </span>
                  {infoData.CardName}
                </li>
                <li>
                  <span>Dir: </span>
                  {infoData.Address2}
                </li>
              </div>
            </InfoWindow>
          ) : undefined}
        </GoogleMapCustom>
      </GridItem>
    </GridContainer>
  );
}
